import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import DrawerComponent from './Drawer';
import { Outlet } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import { useTheme } from '@mui/material/styles';
// redux
import { useSelector, useDispatch } from 'react-redux';
import useStyles from "@hooks/useStyles";
import CommonDrawer from './CommonDrawer';
import { isAdmin} from '@util/helper'

const drawerWidth = 240;

export default function AdminDrawer() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const schools = useSelector(state => state.schoolReducer)
  const account = useSelector(state => state.accountReducer)

  const sideMenu = [
    // {text:'Test',     to:'/scm/test'},

    {text:'divider', visible: true},
    {text:'대시보드', to: '/admin/dashboard', visible: isAdmin(account) },
    {text:'시그널',   to:'/user/signal', visible: true},
    {text:'사용자',   to:'/admin/user', visible: isAdmin(account)},
    {text:'지갑',   to:'/user/wallet', visible: true},
    {text:'설정',   to:'/user/usc', visible: true},

  ]

  return (
    <CommonDrawer sideMenu={sideMenu}  title={'Deck'} barBgColor='#000'/>
	)
}
